module.exports = __webpack_public_path__ + "static/media/beinex.81d87a37.png";